import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import OffscreenRight from '~/components/OffscreenRight';
import linkedin from '~/icons/social/linkedin.svg';
import sliderArrow from '~/icons/slider-arrow.svg';
import Image from '~/components/Dynamic/Image';

export default ({ heading, teamMembers }) => {
  const firstSwiper = React.useRef(null);
  React.useEffect(() => {}, [firstSwiper]);

  return (
    <>
      <header className="container flex flex-col justify-between mb-16 md:flex-row md:items-center">
        <h2 className="mb-4 text-center text-h2 md:mb-0 md:text-left">{heading}</h2>
        <div className="flex justify-center md:justify-start">
          <button
            className="p-1 transition-opacity outline-none opacity-100 hover:opacity-50"
            onClick={() => firstSwiper.current.swiper.slidePrev()}
          >
            <div className="transform rotate-180">
              <img src={sliderArrow} />
            </div>
          </button>
          <button
            className="p-1 transition-opacity outline-none opacity-100 hover:opacity-50"
            onClick={() => firstSwiper.current.swiper.slideNext()}
          >
            <div>
              <img src={sliderArrow} />
            </div>
          </button>
        </div>
      </header>
      <OffscreenRight>
        <Swiper ref={firstSwiper} loop={true} slidesPerView={'auto'} spaceBetween={30}>
          {teamMembers.map((member, i) => (
            <SwiperSlide key={`member${i}`} className="w-full sm:max-w-xs">
              <div>
                <Image blok={member?.icon} />
                <div className="mt-4 text-center md:text-left">
                  <h4 className="font-bold text-18px font-heading">{member?.heading}</h4>
                  <h5 className="text-14px font-heading">{member?.content}</h5>
                  {member?.button[0]?.button?.url?.length > 0 && (
                    <a
                      href={member?.button[0].button?.url}
                      target="_blank"
                      rel="noreferrer noopener"
                      className="inline-block pt-5 pl-5 -ml-5 transition-opacity duration-200 opacity-50 hover:opacity-100"
                    >
                      <img src={linkedin} alt="" className="w-5" />
                    </a>
                  )}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </OffscreenRight>
    </>
  );
};
